module.exports = __webpack_public_path__ + "img/icon-xlsx-document-2.eefa8fa0.svg";